import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import * as Styled from './styles';

const RadioButton = ({ value, onSelect, size }) => {
    const [isSelected, setIsSelected] = useState(value);

    useEffect(() => {
        if (onSelect && isSelected) {
            onSelect(isSelected);
        }
    }, [isSelected, onSelect]);

    useEffect(() => {
        setIsSelected(value);
    }, [value, setIsSelected]);

    return (
        <Styled.RadioBackground
            data-test-id="radio-button-div"
            size={size}
            isSelected={isSelected}
            onClick={() => setIsSelected(true)}
            onKeyDown={(e) => handleKeyPress(e, () => setIsSelected(true))}
        >
            {isSelected && <Styled.RadioSelected data-test-id="radio-button-selected" size={size} />}
        </Styled.RadioBackground>
    );
};

RadioButton.defaultProps = {
    size: 16,
    onSelect: null,
};

RadioButton.propTypes = {
    value: PropTypes.bool.isRequired,
    onSelect: PropTypes.func,
    size: PropTypes.number,
};

export default RadioButton;
